// extracted by mini-css-extract-plugin
export default {"blogHeaderRow":"Blog_blogHeaderRow__Nz+W9","searchCol":"Blog_searchCol__JvLSG","buttonCol":"Blog_buttonCol__5DRvN"};